export function getSelector(...keys: string[]) {
	return (keys || []).join('-');
}
